import { z } from 'zod';
import { isoTimestampSchema } from './common';

/**
 * Auth contract (API_DOCS.md — Auth). Single-user dashboard: login takes only a password,
 * which is verified against the argon2id hash of the one `users` row (ARCHITECTURE.md §10).
 */

/** Minimum length is enforced here so a weak password can never reach the hasher. */
export const passwordSchema = z.string().min(12).max(256);

export const loginRequestSchema = z.object({
  password: z.string().min(1).max(256),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const tokenResponseSchema = z.object({
  token: z.string().min(1),
  expiresAt: isoTimestampSchema,
});
export type TokenResponse = z.infer<typeof tokenResponseSchema>;

export const passwordChangeRequestSchema = z.object({
  current: z.string().min(1).max(256),
  next: passwordSchema,
});
export type PasswordChangeRequest = z.infer<typeof passwordChangeRequestSchema>;

/** Decoded JWT claims. `sub` is the single user's uuid. */
export const jwtClaimsSchema = z.object({
  sub: z.string().uuid(),
  email: z.string().email(),
  iat: z.number().int(),
  exp: z.number().int(),
});
export type JwtClaims = z.infer<typeof jwtClaimsSchema>;
